var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dt',{staticClass:"mt-4 text-sm md:text-base font-semibold text-indigo-600 underline cursor-pointer",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._t("question")],2),(_vm.visible)?_c('dd',{staticClass:"text-sm md:text-base text-indigo-500"},[_vm._t("answer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }